/************  GESTION DES BLOCS *****************/


  $(window).load(setupBlocks);
  var swiper = null;
  
  function setupBlocks() {
    initBlockMedia();
    initSwiperSlider();
    initMasonryBlock();
    initblockpushproducts();
  }
  
  // Fonction qui permet de lire une vidéo
  function initBlockMedia() {
    $(".recettepage-thumbnail, .blocktextimg-media.has-video, .blockmedia-media.has-video").click(function () {
      if (!$(this).hasClass("showVideo")) $(this).addClass("showVideo");
    });
  }
  
  function initblockpushproducts() {
    $(".blockpushproducts .tag").on("click", function (e) {
      e.preventDefault();
      $(".blockpushproducts .tag").removeClass("active");
      $(this).addClass("active");
      const data = {
        action: "filter_products",
        postId: $(".blockpushproducts").attr("data-id"),
        terms: $(".blockpushproducts").attr("data-terms"),
        cat: $(this).attr("data-cat"),
        security: site.security,
      };
      $('.loader').addClass('show');
      $.post(site.ajaxurl, data, function (response) {
        console.log($.trim(response));
        console.log($.trim(response) === '');
        $('.loader').removeClass('show');
        if ($.trim(response) !== '') {
          $(".blockpushproducts-products").html(response);
        } else if ($.trim(response) === '') {
          $(".blockpushproducts-products").html(
            "<p style='font-size:18px ;margin: 35px 10px 0 10px;'>Aucun produit ne correspond à vos critères de filtres</p>"
          );
        }
      });
    });
  }

  function initMasonryBlock() {
    var masonry = "";
    var size = 280;
    if($(window).width() >= 1500) size = 330;
    
    if ($(window).width() >= 1000) {
      masonry = $(".blocklastestnews-slides").masonry({
        columnWidth: size,
        gutter: 20,
        itemSelector: ".swiper-slide",
        horizontalOrder: true,
        fitWidth: false,
        resize: true
      });
    }
    
    $(window).resize(function () {
      if ($(window).width() < 1000 && typeof masonry === "object") {
        $(".blocklastestnews-slides").masonry("destroy");
        masonry = "";
      } else if ($(window).width() >= 1000) {
        if(masonry === "object") $(".blocklastestnews-slides").masonry("destroy");
        masonry = $(".blocklastestnews-slides").masonry({
          columnWidth: size,
          gutter: 20,
          itemSelector: ".swiper-slide",
          horizontalOrder: true,
          fitWidth: false,
          resize: true
        });
      }
    });
  }
  
  // Fonction pour gérer les slider
  function initSwiperSlider() {
    swiper = new Swiper('.swiper', {
      navigation: {
        nextEl: '.btn-next',
        prevEl: '.btn-prev',
      },
      spaceBetween: 20,
      slidesPerView: 'auto'
    });
  }